import { http } from "../plugin/http2-common";

class CategoryService {
  listWithProducts(surveyId) {
    return http.get("/category/list-with-producs/" + surveyId);
  }
}

export default new CategoryService();
